import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
// import { View } from 'react-native'
// import WebView from 'react-native-webview'
import { KTSVG } from '../../../../_metronic/helpers'
// import { useAuth } from '../../auth/core/Auth'

type Props = {
    show: boolean
    handleClose: () => void
    className: string
    title: string
    description: string
    avatar: string
    link: string | undefined
}

export const MyWebVieWModel: React.FC<Props> = ({ show, handleClose, className, title, description, avatar, link, }) => {
    useEffect(() => {
        initMap()
    }, [])

    //const [location, setLocation] = useState(data.location)
    const dissmissLocation = () => {
        //setLocation(data.location)
        handleClose()
    }

    const initMap = () => { }

    return (
        <Modal
            className='modal fade'
            id='kt_modal_test'
            data-backdrop='static'
            tabIndex={-1}
            role='model'
            show={show}
            dialogClassName='modal-fullscreen'
            aria-hidden='true'
            onHide={dissmissLocation}
        >
            <div className='modal-content'>
                <div className='modal-header'>
                    <h5 className='modal-title'>{title}</h5>

                    <div
                        className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                        onClick={dissmissLocation}
                    >
                        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-4x' />
                    </div>
                </div>
                <div className='modal-body'>
                    <div className=''>
                        {/* begin::Header 
                        <div className='card-header border-0'>
                           

                        </div>
                        {/* end::Header */}
                        {/* begin::Body */}
                        <div className=''>
                            <iframe title='load' src={link} width={'100%'}
                                height={'700px'}
                                style={{
                                    overflow: 'visible'
                                }}
                            > </iframe>


                            {/* 
                            <div dangerouslySetInnerHTML={{
                                __html: `"<iframe src='${link}'  width={'100%'} height={'700px'}
                                style={{
                                    overflow: 'visible'
                                }}/>"`}} />
                             <iframe title='load' src={link} width={'100%'}
                                height={'700px'}
                                style={{
                                    overflow: 'visible'
                                }}
                                sandbox=''
                            > </iframe>


                            type="text/html"
                            <View style={{ flex: 1 }}>
                                <WebView
                                    source={{ uri: "https://futurisk.in/" }}
                                    style={{ marginTop: 22, flex: 1 }}
                                />
                            </View> */}



                        </div>
                        {/* end::Body */}
                    </div>

                </div>

            </div >
        </Modal >

    )
}

